import { StudentReportData, CourseAssignmentDetail } from "@/services/studentReportingService";

export const reportExportUtils = {
  formatDuration(minutes: number): string {
    if (minutes === 0) return '0h';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
  },

  formatPercentage(value: number | null): string {
    if (value === null) return 'N/A';
    return `${value.toFixed(1)}%`;
  },

  formatDate(dateString: string | null): string {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  },

  exportAllStudentsToCSV(data: StudentReportData[]): void {
    const headers = [
      'Student Name',
      'Email',
      'Total Courses',
      'Active',
      'In Progress',
      'Completed',
      'Certificates',
      'Avg Grade (%)',
      'Time Spent (hours)',
      'Completion Rate (%)',
      'Last Activity',
    ];

    const rows = data.map(student => [
      student.name,
      student.email,
      student.totalCourses,
      student.activeCourses,
      student.inProgressCourses,
      student.completedCourses,
      student.certificatesEarned,
      student.averageGrade !== null ? student.averageGrade.toFixed(1) : 'N/A',
      (student.totalTimeSpent / 60).toFixed(1),
      student.completionRate.toFixed(1),
      this.formatDate(student.lastActivityDate),
    ]);

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${cell}"`).join(',')),
    ].join('\n');

    this.downloadCSV(csvContent, `all-students-report-${new Date().toISOString().split('T')[0]}.csv`);
  },

  exportIndividualStudentToCSV(data: CourseAssignmentDetail[]): void {
    if (data.length === 0) {
      console.warn('No data to export');
      return;
    }

    const studentName = data[0].studentName.replace(/\s+/g, '-').toLowerCase();

    const headers = [
      'Course Title',
      'Category',
      'Level',
      'Date Assigned',
      'Status',
      'Completion Date',
      'Final Grade (%)',
      'Time Spent (hours)',
      'Certificate',
    ];

    const rows = data.map(assignment => [
      assignment.courseTitle,
      assignment.category,
      assignment.level,
      this.formatDate(assignment.assignedDate),
      assignment.status,
      this.formatDate(assignment.completionDate),
      assignment.finalGrade !== null ? assignment.finalGrade.toFixed(1) : 'N/A',
      (assignment.timeSpent / 60).toFixed(1),
      assignment.hasCertificate ? 'Yes' : 'No',
    ]);

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${cell}"`).join(',')),
    ].join('\n');

    this.downloadCSV(
      csvContent,
      `student-report-${studentName}-${new Date().toISOString().split('T')[0]}.csv`
    );
  },

  downloadCSV(content: string, filename: string): void {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
};
